const ageFromDob = dob => {
	if (dob === null) return 0;
	return Math.floor((new Date() - new Date(dob).getTime()) / (365.25 * 24 * 60 * 60 * 1000));
};

export {ageFromDob};
